"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bulkEvaluate = exports.addShowToData = exports.createEmptyResults = exports.createEmptyPriceList = exports.createEmptyPriceLists = exports.getEmptyQuantityBreaks = exports.createEmptyRows = exports.createEmptyColumns = exports.getRowData = exports.formAttributeMap = exports.createSubHeaders = exports.makeCancelable = exports.buildShippingData = exports.getAllCustomQuantities = exports.calculateDays = exports.getValues = exports.capitalize = exports.isEmptyArray = exports.deepClone = exports.DEFAULT_QUANTITY_BREAKS = exports.LIST_PRICE = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _productPrice = require("./productPrice");

var LIST_PRICE = 'LIST PRICE';
exports.LIST_PRICE = LIST_PRICE;
var DEFAULT_QUANTITY_BREAKS = [1, 125, 250, 500, 1000, 2000, 2500, 5000, 7500, 10000];
exports.DEFAULT_QUANTITY_BREAKS = DEFAULT_QUANTITY_BREAKS;

var deepClone = function deepClone(item) {
  return JSON.parse(JSON.stringify(item));
};

exports.deepClone = deepClone;

var isEmptyArray = function isEmptyArray(array) {
  return !(array && array.length);
};

exports.isEmptyArray = isEmptyArray;

var capitalize = function capitalize(str) {
  if (str && typeof str === 'string' && str.length > 1) return str.charAt(0).toUpperCase() + str.slice(1);
  return str;
};

exports.capitalize = capitalize;

var getValues = function getValues(pivot) {
  return !isEmptyArray(pivot.selectedValues) && pivot.selectedValues || (!isEmptyArray(pivot.defaults) ? pivot.defaults : pivot.values);
};

exports.getValues = getValues;

var calculateDays = function calculateDays(units, time) {
  switch (units) {
    case 'DD':
      return time;

    case 'HH':
      return Math.ceil(time / 24);

    default:
      return 0;
  }
};

exports.calculateDays = calculateDays;

var getAllCustomQuantities = function getAllCustomQuantities(promises) {
  return Promise.all(promises).then(function (customQuantities) {
    var combinedQuantities = [];
    customQuantities.forEach(function (customQuantity) {
      if (isEmptyArray(customQuantity)) {
        customQuantity = DEFAULT_QUANTITY_BREAKS;
      }

      combinedQuantities = (0, _toConsumableArray2.default)(new Set([].concat((0, _toConsumableArray2.default)(combinedQuantities), (0, _toConsumableArray2.default)(customQuantity))));
    });
    return combinedQuantities;
  });
};

exports.getAllCustomQuantities = getAllCustomQuantities;

var buildShippingData = function buildShippingData(shippingCost, shippingPrice, quantityBreaks) {
  var data = {};
  quantityBreaks.forEach(function (qty, index) {
    if (shippingPrice && shippingPrice[index]) data[qty] = shippingPrice[index].price;else data[qty] = {
      amount: shippingCost[index] ? shippingCost[index].shippingCost : null,
      currency: shippingCost[index] ? shippingCost[index].currencyCode : null
    };
  });
  return data;
};

exports.buildShippingData = buildShippingData;

var makeCancelable = function makeCancelable(promise) {
  var cancelled = false;
  var cancelablePromise = new Promise(function (resolve, reject) {
    promise.then(function (val) {
      return cancelled ? reject({
        isCanceled: true
      }) : resolve(val);
    }, function (error) {
      return cancelled ? reject({
        isCanceled: true
      }) : reject(error);
    });
  });
  return {
    promise: cancelablePromise,
    cancel: function cancel() {
      cancelled = true;
    }
  };
};

exports.makeCancelable = makeCancelable;

var createSubHeaders = function createSubHeaders(prefix, selectedColumns, index) {
  var headers = [];
  var pivot = selectedColumns[index];
  var values = getValues(pivot);
  values.forEach(function (attributeValue) {
    var header = {};
    header.name = attributeValue;
    attributeValue = attributeValue.toString().replace('.', '-');
    header.value = "".concat(prefix).concat(attributeValue, "|");

    if (index < selectedColumns.length - 1) {
      header.isParent = true;
      header.children = createSubHeaders(header.value, selectedColumns, index + 1);
    }

    headers.push(header);
  });
  return headers;
};

exports.createSubHeaders = createSubHeaders;

var formAttributeMap = function formAttributeMap(allAttributes, pivot) {
  var newAttributes = {};
  Object.keys(allAttributes).forEach(function (attributeValue) {
    var values = getValues(pivot);
    values.forEach(function (value) {
      var newAttributeSelections = deepClone(allAttributes[attributeValue]);
      newAttributeSelections.push({
        attributeValue: value,
        attributeKey: pivot.key,
        class: pivot.class
      });
      newAttributes["".concat(attributeValue, "|").concat(value)] = newAttributeSelections;
    });
  });
  return newAttributes;
};

exports.formAttributeMap = formAttributeMap;

var getRowData = function getRowData(results, selectedRow) {
  if (!results) return null;
  var rowData = {};

  if (selectedRow) {
    var key = selectedRow.key;
    var values = getValues(selectedRow);
    values.forEach(function (value) {
      rowData[value] = {};
      rowData[value][key] = value;
    });
  } else {
    rowData['|'] = {};
  }

  results.forEach(function (result) {
    if (result) {
      Object.keys(result).forEach(function (sku) {
        Object.keys(result[sku]).forEach(function (buyerId) {
          Object.keys(result[sku][buyerId]).forEach(function (rowValue) {
            Object.keys(result[sku][buyerId][rowValue]).forEach(function (id) {
              var modifiedId = id.toString().replace('.', '-');

              if (selectedRow) {
                var combinedId = "".concat(sku, "|").concat(buyerId, "|").concat(modifiedId);
                rowData[rowValue][combinedId] = result[sku][buyerId][rowValue][id];
              } else {
                var _combinedId = "".concat(sku, "|").concat(buyerId, "|").concat(rowValue).concat(modifiedId);

                rowData['|'][_combinedId] = result[sku][buyerId][rowValue][id];
              }
            });
          });
        });
      });
    }
  });
  rowData = Object.keys(rowData).sort(function (a, b) {
    return a - b;
  }).map(function (item) {
    return rowData[item];
  });
  return rowData;
};

exports.getRowData = getRowData;

var createEmptyColumns = function createEmptyColumns(prefix, selectedColumns, index) {
  if (index === selectedColumns.length - 1) {
    var _values = getValues(selectedColumns[index]);

    return _values.map(function (value) {
      var key = "".concat(prefix).concat(value, "|");
      return (0, _defineProperty2.default)({}, key, {
        price: '-'
      });
    });
  }

  var combinedResult = [];
  var values = getValues(selectedColumns[index]);
  values.forEach(function (value) {
    var newPrefix = "".concat(prefix).concat(value, "|");
    var result = createEmptyColumns(newPrefix, selectedColumns, index + 1);
    result.forEach(function (item) {
      return combinedResult.push(item);
    });
  });
  return combinedResult;
};

exports.createEmptyColumns = createEmptyColumns;

var createEmptyRows = function createEmptyRows(mcpSku, contracts, fulfillerId, selectedRow, selectedColumns) {
  if (!selectedRow || isEmptyArray(selectedColumns)) {
    return null;
  }

  var rowResults = {};
  var emptyResults = {};
  var values = getValues(selectedRow);
  values.forEach(function (value) {
    rowResults[value] = {};
    var results = createEmptyColumns('', selectedColumns, 0);
    results.forEach(function (result) {
      Object.keys(result).forEach(function (key) {
        rowResults[value][key] = result[key];
      });
    });
  });
  contracts.forEach(function (contract) {
    if (contract && contract.seller && contract.seller.sellerId === fulfillerId && contract.buyer && contract.buyer.buyerId) {
      emptyResults[contract.buyer.buyerId] = rowResults;
    }
  });
  return (0, _defineProperty2.default)({}, mcpSku, emptyResults);
};

exports.createEmptyRows = createEmptyRows;

var getEmptyQuantityBreaks = function getEmptyQuantityBreaks(quantities) {
  return quantities.map(function (quantity) {
    return {
      quantity: quantity,
      price: '-'
    };
  });
};

exports.getEmptyQuantityBreaks = getEmptyQuantityBreaks;

var createEmptyPriceLists = function createEmptyPriceLists(mcpSku, contracts, fulfillerId, quantities) {
  var quantityBreaks = quantities.map(function (quantity) {
    return {
      quantity: quantity,
      price: '-'
    };
  });
  var emptyResults = [];
  contracts.forEach(function (contract) {
    if (contract && contract.seller && contract.seller.sellerId === fulfillerId && contract.buyer) {
      var buyer = contract.buyer,
          seller = contract.seller;

      if (emptyResults.length === 0) {
        emptyResults.push({
          mcpSku: mcpSku,
          buyer: {
            buyerType: 'merchants',
            buyerId: LIST_PRICE
          },
          seller: seller,
          quantityBreaks: quantityBreaks
        });
      }

      emptyResults.push({
        mcpSku: mcpSku,
        buyer: buyer,
        seller: seller,
        quantityBreaks: quantityBreaks
      });
    }
  });
  return emptyResults;
};

exports.createEmptyPriceLists = createEmptyPriceLists;

var createEmptyPriceList = function createEmptyPriceList(mcpSku, buyer, seller, quantities) {
  var quantityBreaks = quantities.map(function (quantity) {
    return {
      quantity: quantity,
      price: '-'
    };
  });

  if (buyer && buyer.buyerId) {
    return {
      mcpSku: mcpSku,
      buyer: buyer,
      seller: seller,
      quantityBreaks: quantityBreaks
    };
  }

  return null;
};

exports.createEmptyPriceList = createEmptyPriceList;

var createEmptyResults = function createEmptyResults(sku, contracts, fulfillerId, quantities, pivoting, selectedRow, selectedColumns) {
  return pivoting ? createEmptyRows(sku, contracts, fulfillerId, selectedRow, selectedColumns) : createEmptyPriceLists(sku, contracts, fulfillerId, quantities);
};

exports.createEmptyResults = createEmptyResults;

var addShowToData = function addShowToData(allResults, hasListPriceArray, allMerchants, numberOfSkus, numberOfColumns, showListPriceFirst, isSingleSkuEnvironment) {
  if (isSingleSkuEnvironment) {
    var i = 0;
    var modifier = 0;

    if (hasListPriceArray[0] && showListPriceFirst) {
      allResults[0].show = LIST_PRICE;

      if (numberOfColumns > 1) {
        allResults[0].isNotDropDown = true;
      }

      modifier = 1;
    }

    for (; i < numberOfColumns - modifier; i += 1) {
      if (allMerchants[0]) {
        allResults[i + modifier].show = allMerchants[0][i];
      } else {
        break;
      }
    }

    if (hasListPriceArray[0] && !showListPriceFirst) {
      allResults[i - 1].show = LIST_PRICE;
    }
  } else if (showListPriceFirst) {
    for (var _i = 0; _i < numberOfSkus; _i += 1) {
      if (hasListPriceArray[_i]) {
        allResults[_i].show = LIST_PRICE;
      } else if (allMerchants[_i]) {
        var _allMerchants$_i = (0, _slicedToArray2.default)(allMerchants[_i], 1);

        allResults[_i].show = _allMerchants$_i[0];
      }
    }
  } else {
    for (var _i2 = 0; _i2 < numberOfSkus; _i2 += 1) {
      if (allMerchants && allMerchants[_i2]) {
        var _allMerchants$_i2 = (0, _slicedToArray2.default)(allMerchants[_i2], 1);

        allResults[_i2].show = _allMerchants$_i2[0];
      } else if (hasListPriceArray[_i2]) {
        allResults[_i2].show = LIST_PRICE;
      }
    }
  }

  return allResults;
};

exports.addShowToData = addShowToData;

var bulkEvaluate = function bulkEvaluate(onGetAccessToken, isProduction, sku, evaluationParameters, fulfillerId, contracts, listPriceModel, quantities, selectedRow, selectedColumns, pivoting) {
  return (0, _productPrice.bulkEval)(onGetAccessToken, isProduction, sku, evaluationParameters, fulfillerId, contracts, listPriceModel, quantities).then(function (results) {
    var parsedResults;
    var pivots = [];

    if (selectedRow) {
      pivots.push(selectedRow);
    }

    if (selectedColumns && selectedColumns.length) {
      selectedColumns.forEach(function (column) {
        return pivots.push(column);
      });
    }

    if (pivoting) {
      parsedResults = {};
      results.forEach(function (result) {
        if (result && result.evaluationGroups) {
          var buyer = result.buyer,
              mcpSku = result.mcpSku,
              evaluationGroups = result.evaluationGroups;
          var prices = {};

          if (!parsedResults[mcpSku]) {
            parsedResults[mcpSku] = {};
          }

          evaluationGroups.forEach(function (group) {
            var inputs = group.inputs,
                price = group.price;
            var matchLength = 0;
            var matches = {};

            if (price) {
              for (var i = 0; i < inputs.length; i += 1) {
                for (var j = 0; j < pivots.length; j += 1) {
                  var pivot = pivots[j];

                  if (inputs[i].attributeKey === pivot.key && inputs[i].class === pivot.class) {
                    matches[pivot.key] = inputs[i].attributeValue;
                    matchLength += 1;
                  }
                }

                if (matchLength === pivots.length) {
                  break;
                }
              }

              var X = matches[pivots[0].key];
              var Y = "".concat(pivots[1] ? matches[pivots[1].key] : '', "|").concat(pivots[2] ? "".concat(matches[pivots[2].key], "|") : '');

              if (!prices[X]) {
                prices[X] = {};
              }

              var amount = price.totalAmount ? price.totalAmount : price.amount;
              prices[X][Y] = {
                price: amount,
                currency: price.currency
              };
            }
          });
          parsedResults[mcpSku][buyer.buyerId] = prices;
        } else {// TODO Error Handling
        }
      });
    } else {
      parsedResults = [];
      results.forEach(function (result) {
        if (result && result.evaluationGroups) {
          var buyer = result.buyer,
              seller = result.seller,
              mcpSku = result.mcpSku,
              evaluationGroups = result.evaluationGroups,
              error = result.error;
          var parsedResult = {
            buyer: buyer,
            seller: seller,
            mcpSku: mcpSku,
            error: error
          };
          var quantityBreaks = [];

          if (evaluationGroups && evaluationGroups.length) {
            evaluationGroups.forEach(function (group) {
              var inputs = group.inputs,
                  price = group.price;
              var quantityBreak = {};

              if (price) {
                var quantityAttribute = inputs.find(function (item) {
                  return item.attributeKey.toLowerCase() === 'quantity';
                });

                if (quantityAttribute) {
                  quantityBreak.quantity = quantityAttribute.attributeValue;
                }

                quantityBreak.price = price.totalAmount ? price.totalAmount : price.amount;

                if (!parsedResult.currency) {
                  parsedResult.currency = price.currency;
                }

                quantityBreaks.push(quantityBreak);
              }
            });
          }

          if (quantityBreaks.length) {
            parsedResult.quantityBreaks = quantityBreaks;
          } else {
            parsedResult.quantityBreaks = getEmptyQuantityBreaks(quantities);
          }

          parsedResults.push(parsedResult);
        } else if (result) {
          var _mcpSku = result.mcpSku,
              _buyer = result.buyer,
              _seller = result.seller;
          parsedResults.push(createEmptyPriceList(_mcpSku, _buyer, _seller, quantities));
        }
      });
    }

    return parsedResults;
  });
};

exports.bulkEvaluate = bulkEvaluate;